import RecruitingPage from './components/RecruitingPage';

export default RecruitingPage;
